// Agreement meeting room credit unit: "Hour" uses freeMeetingRoomHours / freeConfrenceRoomHours,
// "SGD" uses meetingRoomCreditAmount. Agreements saved before the unit existed are "Hour".
export const MEETING_ROOM_CREDIT_UNITS = [
  { name: "Hour", value: "Hour" },
  { name: "SGD", value: "SGD" },
];

export const isSgdMeetingCredit = (agreement) => agreement?.meetingRoomCreditUnit === "SGD";
